import { Subject } from "@biblioteksentralen/cordata";
import { SiteSearchConfig } from "../../../../../../../searchAndCollection/searchApi/searchConfig";
import { searchWorks } from "../../../../../../../searchAndCollection/searchApi/searchWorks";
import { WorksData } from "../../personer/[agentBibbiIdAndNorafId]/fetchAgentWorksData";

export type SubjectPageData = {
  subject: Subject;
  initialWorksData: WorksData;
};

export type FetchSubjectWorksProps = { subjectId: string; page: number; searchConfig: SiteSearchConfig };

export const fetchWorksForSubject = ({ subjectId, page, searchConfig }: FetchSubjectWorksProps) => {
  return searchWorks(searchConfig, {
    filter: { "plas.subjects": [subjectId] },
    page,
    size: 9,
  });
};
